import React from 'react'
import { Button } from "antd"

import { FlexRow } from "../../../FlexboxReusables/FlexItems"
import { FormattedMessage } from "react-intl"

type ButtonRowProps = {
  currentStep: number
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  isCurrentStepValid: () => boolean
}
  
export const ButtonRow: React.FC<ButtonRowProps> = ({ currentStep, setCurrentStep, isCurrentStepValid }) => {
  return (
    <>
      <FlexRow justifyContent='space-between' margin='1em 0' padding='0 3em'>
        <Button
          onClick={() => setCurrentStep((prev) => prev - 1)}
          disabled={currentStep === 0}
        >
          <FormattedMessage id='generic.previous' />
        </Button>
        <Button
          type="primary"
          onClick={() => setCurrentStep((prev) => prev + 1)}
          disabled={currentStep === 3 || !isCurrentStepValid()}
        >
          <FormattedMessage id='generic.next' />
        </Button>
      </FlexRow>
    </>
  )
}